module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven Barnes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Steven Barnes")]), _vm._v(" is a "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling, Hugo Award–nominated author of "), _c('I', [_vm._v("Twelve Days")]), _vm._v(" among other novels, a screenwriter, and creator of the Lifewriting™ writing course, which he has taught nationwide. He recently won an NAACP Image Award as coauthor of the Tennyson Hardwick mystery series with his spouse, Tananarive Due, and actor Blair Underwood.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/l23hjB/tc-custom/9781466849082.jpg?1721099588518",
      "alt": "This image is the cover for the book Twelve Days"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twelve Days\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the acclaimed author’s paranormal thriller, a broken family struggles to hold itself together against a plot to unleash global genocide.")]), _c('br'), _c('br'), _vm._v("Around the world, leaders and notorious criminals alike are mysteriously dying. A terrorist group promises a wave of death within two months. And as this global crisis unfolds, the lives of a shattered family and a broken soldier are about to be transformed in the bustling city of Atlanta."), _c('br'), _c('br'), _vm._v("Journalist Olympia Dorsey is desperate to help her teenage daughter and autistic son heal from the personal tragedy they all have suffered. Her neighbor Terry, a special forces veteran, wants to be there for her and the kids—even as he engages in dangerous secret activities. When Terry and the family visit an unusual martial arts exhibition, they meet a teacher of singular skill who offers a way for Olympia’s son to transcend his condition."), _c('br'), _c('br'), _vm._v("As the death toll gains momentum and society itself teeters on the edge of collapse, Olympia’s fragile clan is placed in jeopardy, and Terry comes to understand the terrible price he must pay to prevent catastrophe.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0